<div class="container-modal" (window:resize)="onResize($event)">
  <div class="carousel-container">
    <div class="header">
      <img src="./assets/temporals/Logo_Akana_Blanco.png" alt="">
      <p class="skip" (click)="navigateToUrl('terms')" id="skip">{{ 'CAROUSEL.SKIP' | translate}}</p>
    </div>
    <!--<mat-carousel timings="250ms ease-in" slidesHeight="100%" [maintainAspectRatio]="false" [autoplay]="false"
      color="accent" maxWidth="auto" slides="4" [loop]="false" [hideArrows]="!arrows" [hideIndicators]="false"
      [useKeyboard]="true" [useMouseWheel]="false" orientation="ltr">
      <mat-carousel-slide [hideOverlay]="true" #matCarouselSlide *ngFor="let slide of carouselImages; let i = index"
        [hideOverlay]="false">
        <div class="all-content">
          <div class="financial-health">
            <div class="content-health">
              <h5>{{ 'CAROUSEL.TRANSLATIONS.HEALTH' | translate }}</h5>
              <h2> {{ 'CAROUSEL.TRANSLATIONS.' + i + '.TITTLE' | translate }}</h2>
              <p [innerHTML]="'CAROUSEL.TRANSLATIONS.' + i + '.DESCRIPTION' | translate"></p>
              <button (click)="navigateToUrl('terms')" *ngIf="i === 3" id="okCarousel" class="btn-ok">OK</button>
              <button (click)="navigateToUrl('terms')" *ngIf="i === 3" id="okCarousel" class="btn-ok-2">¡Empecemos!</button>
            </div>
          </div>
          <div class="ball-background">
            <div class="content">
              <img class="person" class="icons" (mousedown)="disableDragging($event)"
                src="./assets/carousel/{{i + 1}}.png" alt="">
              <img class="oval" (mousedown)="disableDragging($event)" src="./assets/carousel/Oval-2.png" alt="">
            </div>
          </div>
        </div>
      </mat-carousel-slide>
    </mat-carousel>-->
    <swiper-container [slidesPerView]="1" [spaceBetween]="30" loop="false" [pagination]="{ clickable: true }" class="carousel" autoHeight="true" id="cardsswiper">
      <ng-container *ngFor="let slide of carouselImages; let i = index">
          <swiper-slide class="carousel-slide-content">
            <div class="all-content">
              <div class="financial-health">
                <div class="content-health">
                  <h5>{{ 'CAROUSEL.TRANSLATIONS.HEALTH' | translate }}</h5>
                  <h2> {{ 'CAROUSEL.TRANSLATIONS.' + i + '.TITTLE' | translate }}</h2>
                  <p [innerHTML]="'CAROUSEL.TRANSLATIONS.' + i + '.DESCRIPTION' | translate"></p>
                  <button (click)="navigateToUrl('terms')" *ngIf="i === 3" id="okCarousel" class="btn-ok">OK</button>
                  <button (click)="navigateToUrl('terms')" *ngIf="i === 3" id="okCarousel" class="btn-ok-2">¡Empecemos!</button>
                </div>
              </div>
              <div class="ball-background">
                <div class="content">
                  <img class="person" class="icons" (mousedown)="disableDragging($event)"
                    src="./assets/carousel/{{i + 1}}.png" alt="">
                  <img class="oval" (mousedown)="disableDragging($event)" src="./assets/carousel/Oval-2.png" alt="">
                </div>
              </div>
            </div>
          </swiper-slide>
      </ng-container>
  </swiper-container>
  <div
          (click)="slidePrev()"
          class="swiper-button-prev"
        ></div>
        <div
          (click)="slideNext()"
          class="swiper-button-next"
        ></div>
  </div>
</div>
